module.exports = __webpack_public_path__ + "static/media/ced-logo.34369b21.svg";